import { Button } from "../Button";
import SidebarModal from "./SidebarModal";

type ConfirmationModalProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
    message: string;
    reason?: string;
    setReason?: (val: string) => void;
}

export default function ConfirmationModal({ open, onClose, onConfirm, onCancel, title, message, reason, setReason }: ConfirmationModalProps) {
    return (
        <SidebarModal
            title={title}
            action={<div className="flex w-full flex-col gap-2"><Button
                onClick={() => onConfirm()}
                className="bg-blue-600 hover:bg-blue-700 w-full rounded-2xl text-white"
                title={"Confirmar"}
            />
                <Button onClick={() => onCancel()}
                    className="bg-transparent hover:bg-transparent text-red-600 underline hover:no-underline" title="Cancelar" />
            </div>}
            open={open} onClose={onClose}>
            <div className="flex flex-col gap-3">
                <h4 className="block text-text font-primary leading-6 text-primaryText">{message}</h4>
                {setReason && <div className="flex flex-col gap-1">
                    <h4 className="text-sm font-bold">Motivo</h4>
                    <textarea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        className="py-1.5 px-2 text-xs font-text rounded-lg border flex-grow border-gray-300 resize-none"
                        placeholder="Ajude-nos a melhorar nossas ferramentas, qual o motivo do cancelamento?"
                        rows={6}
                    />
                </div>}
            </div>
        </SidebarModal>
    )
}
